import React, { useState, useEffect } from 'react'
import { Select, Form, Row, Col } from 'antd'
import { voicesData } from './listVoices'
import { useTranslation } from 'react-i18next'

const { Option } = Select

const ListVoices = props => {
  const normalizeAccent = accent =>
    (accent || '')
      .trim()
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase())

  const [selectedGender, setSelectedGender] = useState(
    props.mazeAvatarId !== undefined
      ? props.mazeAvatarId ===
        (process.env.NODE_ENV === 'development' ? 48683 : 1238494)
        ? 'male'
        : 'female'
      : null
  ) // dev
  // const [selectedGender, setSelectedGender] = useState((props.mazeAvatarId !== undefined ? props.mazeAvatarId === 1238494 ? 'male' : 'female' : null)); // prod
  const [selectedVoice, setSelectedVoice] = useState(props.voice_name || null)
  const [selectedId, setselectedId] = useState(null)
  const [selectedAccent, setSelectedAccent] = useState(
    props.mazeVoiceAccent ? normalizeAccent(props.mazeVoiceAccent) : null
  )
  const [filteredVoices, setFilteredVoices] = useState([])
  const [sortedAccents, setSortedAccents] = useState([])

  const handleGenderChange = value => {
    setSelectedGender(value)
    setSelectedVoice(null)
    setselectedId(null)
    setSelectedAccent(null)
  }

  const handleVoiceChange = value => {
    const selected = filteredVoices.find(voice => voice.voice_id === value)
    if (!selected) return

    setSelectedVoice(selected.name)
    setselectedId(selected.voice_id)
    setSelectedAccent(null)
  }

  const handleAccentChange = value => {
    setSelectedAccent(value)
    props.handleElevenLabsVoiceSelect({
      selectedGender: selectedGender,
      selectedVoice: selectedVoice,
      selectedId: selectedId,
      selectedAccent: value,
      selectedVoiceType: props.selectedVoiceType
    })
  }

  useEffect(() => {
    if (selectedGender) {
      const voices = voicesData.voices
        .filter(voice => voice.labels.gender === selectedGender)
        .sort((a, b) => a.name.localeCompare(b.name))
      setFilteredVoices(voices)

      const uniqueAccents = [
        ...new Set(voices.map(voice => normalizeAccent(voice.labels.accent)))
      ].sort()
      setSortedAccents(uniqueAccents)
    } else {
      setFilteredVoices([])
      setSortedAccents([])
    }
  }, [selectedGender])

  const { t } = useTranslation()

  return (
    <Form layout="vertical">
      <Row gutter={16} align="middle" style={{ marginBottom: '16px' }}>
        <Col span={6}>
          <label style={{ marginTop: '0.5em' }}>{t('v4:gender')}</label>
        </Col>
        <Col span={18}>
          <Select
            placeholder={t('v4:select_gender')}
            onChange={handleGenderChange}
            value={selectedGender}
            style={{ width: '100%' }}
            disabled={!props.selectedVoiceType}
          >
            <Option value="male">{t('media:male')}</Option>
            <Option value="female">{t('media:female')}</Option>
          </Select>
        </Col>
      </Row>

      <Row gutter={16} align="middle" style={{ marginBottom: '16px' }}>
        <Col span={6}>
          <label style={{ marginTop: '0.5em' }}>{t('v4:voice_name')}</label>
        </Col>
        <Col span={18}>
          <Select
            placeholder="Select Voice"
            value={selectedVoice}
            onChange={handleVoiceChange}
            disabled={!filteredVoices.length}
            style={{ width: '100%' }}
          >
            {filteredVoices.map((voice, index) => (
              <Option
                key={`${voice.voice_id}-${index}`}
                value={voice.voice_id}
              >
                {voice.name}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>

      <Row gutter={16} align="middle">
        <Col span={6}>
          <label style={{ marginTop: '0.5em' }}>{t('v4:accent')}</label>
        </Col>
        <Col span={18}>
          <Select
            placeholder={t('v4:select_accent')}
            value={selectedAccent}
            onChange={handleAccentChange}
            disabled={!sortedAccents.length}
            style={{ width: '100%' }}
          >
            {sortedAccents.map(accent => (
              <Option key={accent} value={accent}>
                {accent}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    </Form>
  )
}

export default ListVoices
